import { CategoryType, CategoryTypeId } from '@diritto/common/content/constants';
import { CategoryNavigationMenu, CategoryNavMenuToCategoryMap } from '@diritto/common/navigation/constant';

export const getCategoryTypeFromId = (categoryId: number) =>
  Object.keys(CategoryTypeId).find(type => CategoryTypeId[type as CategoryType] === categoryId) as CategoryType;

export const getCategoryNavMenuFromCategoryType = (categoryType: CategoryType) =>
  Object.keys(CategoryNavMenuToCategoryMap).find(
    menu => CategoryNavMenuToCategoryMap[menu as CategoryNavigationMenu] === categoryType,
  ) as CategoryNavigationMenu;
